export default function NayaxPayment() {
  return (
    <section className="py-24 bg-gradient-to-br from-amber-50 via-white to-orange-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-amber-400/20 rounded-full blur-2xl"></div>
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-orange-400/20 rounded-full blur-2xl"></div>
              <img
                src="https://static.readdy.ai/image/e468a762cbf2c4de3f207872d8ecdaa7/fcad817af0908cc8ddb7831c10f53d1e.png"
                alt="Nayax VPOS Touch Credit Card Reader - Yellow cashless payment device for vending machines"
                className="relative w-full h-auto max-w-lg mx-auto drop-shadow-2xl"
              />
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="inline-flex items-center bg-amber-100 text-amber-800 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-shield-check-line text-lg"></i>
              </div>
              Industry-Leading Technology
            </div>

            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Nayax Payment System
              <span className="block text-orange-600 mt-2">At No Cost to You</span>
            </h2>

            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Every VE Goodies vending machine comes equipped with the state-of-the-art <strong>Nayax VPOS Touch</strong> cashless payment system - completely free of charge. Accept all major payment methods and provide your customers with a seamless, modern purchasing experience.
            </p>

            <div className="bg-white rounded-2xl shadow-lg p-8 mb-8 border-2 border-orange-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Payment Options Included:</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center bg-orange-100 rounded-full mr-3 flex-shrink-0 mt-0.5">
                    <i className="ri-bank-card-line text-orange-600 text-sm"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900 text-sm">Credit &amp; Debit Cards</div>
                    <div className="text-xs text-gray-600">Visa, Mastercard, Amex, Discover</div>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center bg-orange-100 rounded-full mr-3 flex-shrink-0 mt-0.5">
                    <i className="ri-smartphone-line text-orange-600 text-sm"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900 text-sm">Mobile Payments</div>
                    <div className="text-xs text-gray-600">Apple Pay, Google Pay, Samsung Pay</div>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center bg-orange-100 rounded-full mr-3 flex-shrink-0 mt-0.5">
                    <i className="ri-contactless-line text-orange-600 text-sm"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900 text-sm">Contactless Tap</div>
                    <div className="text-xs text-gray-600">NFC &amp; RFID enabled</div>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center bg-orange-100 rounded-full mr-3 flex-shrink-0 mt-0.5">
                    <i className="ri-qr-code-line text-orange-600 text-sm"></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900 text-sm">QR Code Payments</div>
                    <div className="text-xs text-gray-600">Scan &amp; pay instantly</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-4 mb-8">
              <div className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center bg-orange-600 rounded-full mr-3 flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-white text-sm font-bold"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Touchscreen Interface</div>
                  <div className="text-sm text-gray-600">Easy-to-use color display for seamless transactions</div>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center bg-orange-600 rounded-full mr-3 flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-white text-sm font-bold"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Real-Time Reporting</div>
                  <div className="text-sm text-gray-600">Track sales and inventory remotely 24/7</div>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center bg-orange-600 rounded-full mr-3 flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-white text-sm font-bold"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900">PCI-DSS Compliant</div>
                  <div className="text-sm text-gray-600">Bank-level security for all transactions</div>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center bg-orange-600 rounded-full mr-3 flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-white text-sm font-bold"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Zero Upfront Cost</div>
                  <div className="text-sm text-gray-600">Included free with every VE Goodies machine</div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-orange-600 to-amber-500 rounded-2xl p-6 text-white">
              <div className="flex items-center mb-3">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full mr-3">
                  <i className="ri-line-chart-line text-2xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold">40% Higher Sales</div>
                  <div className="text-sm text-white/90">Average increase with cashless payments</div>
                </div>
              </div>
              <p className="text-sm text-white/90">
                Studies show that cashless payment systems significantly boost vending machine revenue by making purchases more convenient for customers.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
